module.exports = __webpack_public_path__ + "img/banner-TV-1__xl.fa71dfaa.jpg";